import { Box, FormControl, Typography, TextField, Button } from '@mui/material';
import {
  ExternalProviderSearchRequest,
  setExternalProviderSearchState,
  useAppDispatch,
  useAppSelector,
  useLazyGetExternalProviderMappingsQuery,
} from 'api';
import { ExternalProviderMappingTable } from './ExternalProviderMappingTable';
import { PageContainer } from 'app';
import SearchIcon from '@mui/icons-material/Search';

export const ExternalProviderMappingPage = () => {
  const { currentMenuItem } = useAppSelector(state => state.menuItem);
  const { searchState } = useAppSelector(
    state => state.externalProviderMapping
  );
  const [trigger, { data, isLoading, isFetching }] =
    useLazyGetExternalProviderMappingsQuery();
  const dispatch = useAppDispatch();

  const handleNpiSearchChange = (value: number) => {
    dispatch(
      setExternalProviderSearchState({
        ...searchState,
        npiSearchValue: value,
      })
    );
  };

  const handleOrgNameSearchChange = (value: string) => {
    dispatch(
      setExternalProviderSearchState({
        ...searchState,
        orgNameSearchValue: value,
      })
    );
  };

  const handleSearch = () => {
    const valid = validateSearchValues();
    if (valid)
      trigger({
        npi: searchState.npiSearchValue,
        organizationName: searchState.orgNameSearchValue,
      } as ExternalProviderSearchRequest);
  };

  function validateSearchValues() {
    let validationErrors = [];
    const searchText = searchState.npiSearchValue as string;

    if (searchState.npiSearchValue) {
      const isNumber = /^\d+$/.test(searchText);
      if (!isNumber) validationErrors.push('Value must be a number');
    }

    dispatch(
      setExternalProviderSearchState({
        ...searchState,
        validationErrors: validationErrors,
      })
    );
    return validationErrors.length === 0;
  }

  return (
    <PageContainer>
      <Typography variant="subtitle1">{currentMenuItem?.text}</Typography>
      <Box display="flex" flexDirection="column">
        <Box
          sx={{
            width: '100%',
            maxWidth: '1200px',
            marginRight: 'auto',
            marginLeft: 'auto',
          }}
        >
          <FormControl
            variant="filled"
            size="small"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '1em',
              alignItems: 'center',
              m: 1,
              minWidth: 120,
            }}
          >
            <TextField
              id="NPI"
              label="NPI"
              defaultValue=""
              variant="filled"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleNpiSearchChange(
                  event.target.value ? Number(event.target.value) : 0
                )
              }
              value={
                searchState.npiSearchValue ? searchState.npiSearchValue : ''
              }
              error={searchState.validationErrors.length > 0}
              helperText={
                <>
                  {searchState.validationErrors.map(err => (
                    <>
                      <span>{err}</span>
                      <br />
                    </>
                  ))}
                </>
              }
              size="small"
              inputProps={{ maxLength: 10, style: { whiteSpace: 'pre-line' } }}
            />
            <TextField
              id="orgName"
              label="Organization Name"
              defaultValue=""
              variant="filled"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleOrgNameSearchChange(event.target.value)
              }
              helperText={<></>}
              value={
                searchState.orgNameSearchValue
                  ? searchState.orgNameSearchValue
                  : ''
              }
              size="small"
              inputProps={{ style: { whiteSpace: 'pre-line' } }}
            />
            <Button
              variant="contained"
              size="small"
              sx={{
                height: '3em',
                padding: '0 1em 0 1em',
                display: 'flex',
              }}
              onClick={handleSearch}
              loading={isLoading}
              loadingPosition="start"
              startIcon={<SearchIcon />}
            >
              <span style={{ paddingTop: '3px' }}>Search</span>
            </Button>
          </FormControl>
          <ExternalProviderMappingTable
            data={data}
            isLoading={isLoading}
            isFetching={isFetching}
          />
        </Box>
      </Box>
    </PageContainer>
  );
};
